import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../helpers/firebase-config.js';

import { getLoggedInUser } from "../helpers/authUtils";

import moment from 'moment'

export function setHospital(data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('hospital')
      .add(data)
      .then(() => resolve(true))
      .catch(error => {
        const erro = {
          error,
          msg:
            'Houve um problema ao cadastrar o Hospital, favor tentar novamente'
        };
        reject(erro);
      });
  });
}

export function updateHospital(id, data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('hospital')
      .doc(id)
      .update(data)
      .then(() => resolve(true))
      .catch(error => {
        const erro = {
          error,
          msg:
            'Houve um problema ao atualizar o Hospital, favor tentar novamente'
        };
        reject(erro);
      });
  });
}

export function getHospital() {
  return new Promise(function (resolve, reject) {
    Libfirebase.firestore()
      .collection('hospital')
      .get()
      .then(snap => {
        let ListHospital = [];
        snap.forEach(doc => {
          const data = {
            id: doc.id,
            hospital: doc.data()
          };
          ListHospital.push(data);
        });

        resolve(ListHospital);
      })
      .catch(erro => {
        const error = {
          erro,
          msg:
            'Houve um erro ao retornar a lista de hospitais, favor tentar novamente mais tarde'
        };
        reject(erro);
      });
  });
}

export function getHospitais(idhospital = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('hospital');

    if (idhospital) {
      ref = ref
        .doc(idhospital)
        .get()
        .then(doc => {

          const data = {
            id: doc.id,
            hospital: doc.data().Nome,
            ativo: doc.data().Ativo,
            endereco: doc.data().endereco,

          };

          resolve(data);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };
          reject(erro);
        });
    } else {
      let list = [];
      ref
        .orderBy('Nome')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const data = {
              id: doc.id,
              hospital: doc.data().Nome,
              ativo: doc.data().Ativo,
              desativadaEm: doc.data().desativadaEm,
              endereco: doc.data().endereco,
            };



            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export function deleteHospital(id) {
  var loggedUser = getLoggedInUser();


  return new Promise(function (resolve, reject) {
    Libfirebase.collection('hospital')
      .doc(id)
      .update({
        Ativo: false,
        desativadaEm: moment().format("DD-MM-YYYY - HH:mm:ss"),
        usuarioDesativacao: loggedUser.id
      })
      .then(success => {
        resolve(true);
      })
      .catch(error => reject(error));
  });
}

export function getHospitalbyId(idhospital) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('hospital');

    if (idhospital) {
      ref = ref
        .doc(idhospital)
        .get()
        .then(doc => {
          const data = {
            id: doc.id,
            hospital: doc.data().Nome,
            ativo: doc.data().Ativo
          };

          resolve(data);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };
          reject(erro);
        });
    } else {
      let list = [];
      ref
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const data = {
              id: doc.id,
              hospital: doc.data().Nome,
              ativo: doc.data().Ativo,
              desativadaEm: doc.data().desativadaEm
            };

            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export async function getHospitaisNew() {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection("hospital")
      .where('Ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        let listHospital = [];

        var final = snapShot.docs.length - 1;
        var count = 0;
        snapShot.forEach(async (doc) => {
          let data = {
            ref: doc.ref,
            id: doc.id,
            hospital: doc.data(),
          };
          listHospital.push(data);
          if (count >= final) {
            resolve(listHospital);
          }
          count++;
        });
      })
      .catch(erro => reject(erro.code));
  });
}

export async function getHospitalById(hospitalId) {
  return new Promise(async function (resolve, reject) {
    await Libfirebase.collection("hospital")
      .doc(hospitalId)
      .get()
      .then(async (snap) => {
        const data = {
          id: snap.id,
          hospital: snap.data(),
        };
        resolve(data);
      }).catch(error => {
        reject(error);
      });
  });
}
